export const API_HOST = 'https://wheelstatic.com/wheel_app/api';
export const DEBUG = false;
